<template>
  <span class="chip" :class="variantClass">
    <span v-if="showDot" class="dot"></span>{{ label }}
  </span>
</template>

<script>
/**
 * Reusable status chip leaf.
 *
 * Variant styles mirror the Claude Design wireframe `.chip` block
 * (AVA Verification Wireframe.html lines 115-125).
 *
 * The colored dot renders only for stateful variants (progress/pass/fail/primary)
 * to match the wireframe — the neutral `default` chip is flat text-only.
 */
const VALID_VARIANTS = ['default', 'progress', 'pass', 'fail', 'primary'];

export default {
  name: 'StatusChip',
  props: {
    label: { type: String, required: true },
    variant: {
      type: String,
      default: 'default',
      validator: (v) => VALID_VARIANTS.includes(v),
    },
  },
  computed: {
    variantClass() {
      return this.variant === 'default' ? null : `chip--${this.variant}`;
    },
    showDot() {
      return this.variant !== 'default';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/verification-tokens';

.chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 22px;
  padding: 0 9px;
  border-radius: $vf-r-full;
  font-size: 11px;
  font-weight: 500;
  background: #f1f1f1;
  color: $vf-ink;
  border: 1px solid $vf-line-soft;

  .dot {
    width: 6px;
    height: 6px;
    border-radius: 999px;
    background: currentColor;
  }

  &.chip--progress {
    background: rgba(217, 119, 6, 0.12);
    color: $vf-pending;
    border-color: rgba(217, 119, 6, 0.3);
  }

  &.chip--pass {
    background: rgba(13, 148, 136, 0.12);
    color: $vf-harvest;
    border-color: rgba(13, 148, 136, 0.3);
  }

  &.chip--fail {
    background: rgba(183, 28, 28, 0.1);
    color: $vf-error;
    border-color: rgba(183, 28, 28, 0.3);
  }

  &.chip--primary {
    background: rgba(3, 98, 76, 0.1);
    color: $vf-primary;
    border-color: rgba(3, 98, 76, 0.3);
  }
}
</style>
